import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "w5d51j1tw__mask0_11690_54780",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#w5d51j1tw__mask0_11690_54780)",
        children: [_jsx("path", {
          d: "M34.0588 0H-4C-5.10457 0 -6 0.89543 -6 2V28C-6 29.1046 -5.10457 30 -4 30H34.0588C35.1634 30 36.0588 29.1046 36.0588 28V2C36.0588 0.89543 35.1634 0 34.0588 0Z",
          fill: "white"
        }), _jsx("mask", {
          id: "5uls2ce64__mask1_11690_54780",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "-6",
          y: "0",
          width: "43",
          height: "30",
          children: _jsx("path", {
            d: "M34.0588 0H-4C-5.10457 0 -6 0.89543 -6 2V28C-6 29.1046 -5.10457 30 -4 30H34.0588C35.1634 30 36.0588 29.1046 36.0588 28V2C36.0588 0.89543 35.1634 0 34.0588 0Z",
            fill: "white"
          })
        }), _jsx("g", {
          mask: "url(#5uls2ce64__mask1_11690_54780)"
        }), _jsx("path", {
          d: "M38 2H-8V28H38V2Z",
          fill: "#C1272D"
        }), _jsx("path", {
          d: "M12.4823 18.4789L13.4431 15.5082L10.925 13.6713H14.0348L14.9956 10.6934L15.9563 13.6713H19.0661L16.5481 15.5082L17.5088 18.4813L15.0004 16.6421L12.4823 18.4789ZM15.5346 16.2521L16.3157 16.825L16.0186 15.903L15.5346 16.2521ZM13.9821 15.9006L13.685 16.8226L14.4661 16.2497L13.9821 15.9006ZM14.1858 15.265L15.0004 15.8597L15.8149 15.265L15.5035 14.3021H14.4948L14.1858 15.265ZM12.8705 14.3021L13.6515 14.8702L13.836 14.3021H12.8705ZM16.1695 14.3021L16.354 14.8702L17.135 14.3021H16.1695ZM14.7033 13.6689H15.3022L15.0004 12.7469L14.7033 13.6689Z",
          fill: "#006233"
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      })]
    }))
  });
};
export default Component;
